import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import logo from "../../assets/boxxdocks-logo-grey.svg"
import { toast } from "react-toastify";
import axios from 'axios';
import { useDispatch, useSelector } from "react-redux";
import { setStateRefresh } from "../../redux/globalSlice";
import { useLocationCodeVerifyMutation } from "../../redux/ServiceApi";

const LocationCode = () => {
    const navigate = useNavigate()
    const [code, setCode] = useState('');
    const [error, setError] = useState('');
    const dispatch = useDispatch();
    const stateRefresh = useSelector((state) => state.global.stateRefresh);
    const [locationCodeVerify] = useLocationCodeVerifyMutation();

    const submitHandler = async (e) => {
        e.preventDefault();

        if (!code.trim()) {
            setError('Please enter a valid location code.');
            return;
        }
        let inputField = {
            qrNumber: code
        }
        locationCodeVerify(inputField)
            .unwrap()
            .then((res) => {
                console.log({ res })
                if (res?.statusCode === 200) {
                    navigate(`/location/${res?.data?._id}?locationName=${res?.data?.locationName}&customerNumber=${res?.data?.vendorId?.customerNumber}&region=${res?.data?.vendorId?.region}`);
                    dispatch(setStateRefresh(!stateRefresh));
                    localStorage.setItem("getServicePage", "Reporting");
                }

            })
            .catch((err) => {
                console.log("error", err)
                 //toast.error(err?.data?.message);
                 setError(err?.data?.message);
            });
    };
    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-lg-12">
                    <div className="main-content">
                        <div className="logo mx-auto">
                            <img src={logo} className="img-fluid mx-auto" alt="" />
                        </div>
                        <p className="mb-0 heading">Enter Location Code</p>

                        <div className="code-box">
                            <form action="">
                                <input type="text" className="code"
                                    placeholder="Enter Code Here"
                                    value={code}
                                    onChange={(e) => {
                                        setCode(e.target.value);
                                        setError('');
                                    }}
                                />
                                {error && <p style={{ color: 'red', marginTop: '10px', marginLeft: '5px' }}>{error}</p>}
                                <div className="button-box">
                                    <button type="button" className="btn-continue" onClick={submitHandler}>Continue</button>

                                </div>
                            </form>
                        </div>


                    </div>
                </div>
            </div>
        </div>

    )
}

export default LocationCode